import React from "react";
import DatepickerComponent from "../../components/UI/DatePicker/DatepickerComponent";
import Dropdown from "../../components/UI/Dropdown/Dropdown";
import { Row, Col } from "react-bootstrap";
import moment from "moment";

export default function filterIzvjestaja(props) {
  let dropdownData = [];

  const { izvjestajParams, dropdownFilterData, dropdownLabel } = props;

  dropdownData.push({ id: 0, name: "BEZ FILTERA" });
  dropdownFilterData.map((element) => dropdownData.push(element));

  let dropdownOptions = dropdownData.map((element) => (
    <option key={element.id} value={element.id}>
      {element.name}
    </option>
  ));

  return (
    <>
      <Row className="mb-2">
        <Col>
          <DatepickerComponent
            id="datOd"
            value={izvjestajParams.datOd}
            handleDayClick={props.datePickerHandler}
            index={{ id: "datOd" }}
            controlLabel="Datum od*"
            width={"100%"}
            errorBorderColor={
              props.datePickerError && "red"
            }
          />
        </Col>
        <Col>
          <DatepickerComponent
            id="datDo"
            value={izvjestajParams.datDo}
            handleDayClick={props.datePickerHandler}
            index={{ id: "datDo" }}
            controlLabel="Datum do*"
            width={"100%"}
            errorBorderColor={
              props.datePickerError && "red"
            }
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Dropdown
            hidden
            value={izvjestajParams.filter}
            onChange={props.dropdownFilterHandler}
            asProperty="select"
            map={dropdownOptions}
            text="Filtriraj izvještaj"
            label={dropdownLabel}
            id="filterIzvjestaja"
          />
        </Col>
      </Row>
    </>
  );
}
